import moment from 'moment'
import lang from '@/lang' // date format

class DateUtils {
  static STANDARD_MINUTE_TIME = 'YYYY-MM-DD HH:mm:ss'

  static STANDARD_DATE_TIME = 'YYYY-MM-DD kk:mm:ss'

  static STANDARD_DATE_MINUTES = 'YYYY-MM-DD kk:mm'

  static STANDARD_MINUTE = 'YYYY-MM-DD HH:mm'

  static STANDARD_DATE_HOURS = 'YYYY-MM-DD kk'

  static STANDARD_DATE = 'YYYY-MM-DD'

  static localTimeZone = -8

  static STANDARD_MINUTE_TIME_S = 'YYYY-MM-DD HH:mm:ss:SSS'

  // private static var format: DateFormatter = new DateFormatter()

  /**
   * 标准的详细时间
   * @param d
   * @return
   */
  static formatStandardDateTime(d) {
    if (d) {
      return moment(d).format(this.STANDARD_MINUTE_TIME)
    }
    return ''
  }
  /**
   * 标准的详细时间-到毫秒
   * @param d
   * @return
   */
  static formatStandardDateTimeS(d) {
    if (d) {
      return moment(d).format(this.STANDARD_MINUTE_TIME_S)
    }
    return ''
  }

  /**
   * 标准的详细时间
   * @param d
   * @return
   */
  static formatStandardDate(d) {
    if (d) {
      return moment(d).format(this.STANDARD_DATE)
    }
    return ''
  }

  /**
   * 自定义格式化
   * @param d
   * @param formatString: "YYYY-MM"
   * @return
   */
  static customFormat(d, formatString) {
    if (d) {
      return moment(d).format(formatString)
    }
    return ''
  }

  /**
   * 获取日期的周数
   * @param dateStr
   * @returns {*}
   */
  static getDateWeek(dateStr) {
    const date = this.dateToStr(dateStr)
    return this.filterWeek(date.getDay())
  }

  /**
   * 字符串日期转日期类型
   * @param dateStr
   * @returns {Date}
   */
  static dateToStr(dateStr) {
    return new Date(dateStr)
  }

  /**
   * 获取周数
   * @param val
   * @returns {VueI18n.TranslateResult}
   */
  static filterWeek(val) {
    switch (val) {
      case 2: return 'TUE'
      case 3: return 'WED'
      case 4: return 'THU'
      case 5: return 'FRI'
      case 6: return 'SAT'
      case 0: return 'SUN'
      case 1:
      default: return 'MON'
    }
  }

  // /**
  //  * 标准的详细时间 如: 11:11:23 20:25
  //  * @param d
  //  * @return
  //  */
  //  static formatStandardDateMinutes(d: Date) {
  //   format.formatString = STANDARD_DATE_MINUTES
  //   return format.format(d)
  // }

  // /**
  //  * 标准的详细时间 如 11:11:23 20:25,但是此处时钟取值为0-23
  //  * @param d
  //  * @return
  //  */
  //  static formatStandardMinutes(d: Date) {
  //   format.formatString = STANDARD_MINUTE
  //   return format.format(d)
  // }

  // /**
  //  * 标准的详细时间
  //  * @param d
  //  * @return
  //  */
  //  static formatStandardDateHours(d: Date) {
  //   format.formatString = STANDARD_DATE_HOURS
  //   return format.format(d)
  // }

  // /**
  //  * 标准的详细时间
  //  * @param d
  //  * @return
  //  */
  //  static formatStandardDate(d: Date) {
  //   format.formatString = STANDARD_DATE
  //   return format.format(d)
  // }

  // /**
  //  * 自定义格式化
  //  * @param d
  //  * @param formatString
  //  * @return
  //  */
  //  static customFormat(d: Date, formatString) {
  //   format.formatString = formatString
  //   return format.format(d)
  // }

  /**
   * 获取经过的总天数。距离 1970 年 1 月 1 日
   * @param date
   * @return int
   */
  static getTotalDays(date) {
    return Number((date.getTime() - this.localTimeZone * 60 * 60 * 1000) / (24 * 60 * 60 * 1000))
  }

  /**
   * 计算两个日期相差天数。
   * 用第一个日期减去第二个。如果前一个日期小于后一个日期，则返回负数
   * @param startDate 第一个日期数，作为基准
   * @param endDate 第二个日期数，作为比较
   * @return diff 两个日期相差天数
   */
  static getBetweenDays(startDate, endDate) {
    // return this.getTotalDays(startDate) - this.getTotalDays(endDate)
    // moment 计算相差的天数
    const date1 = moment(startDate)
    const date2 = moment(endDate)
    const diff = date2.diff(date1, 'days')// 计算相差的day数
    // console.log('diff====', diff)
    return diff
  }

  /**
   * 获取日期的当月第一天(默认当天时间)
   * @param date
   * @returns {Date}
   */
  static getMonthFirst(date = new Date()) {
    date.setDate(1)
    return date
  }

  /**
   * 获取日期的该周的第一天(默认当天时间)，周日为第一天
   * @param date
   * @returns {Date}
   */
  static getFirstDayOfWeek(date = new Date()) {
    const weekday = date.getDay() || 7 // 获取星期几,getDay()返回值是 0（周日） 到 6（周六） 之间的一个整数。0||7为7，即weekday的值为1-7
    date.setDate(date.getDate() - weekday) // 往前算（weekday-1）天，年份、月份会自动变化
    return date
  }
  // /**
  //  *根据相差的天数获取截至时间
  //  * @param startDate 第一个日期数，作为基准
  //  * @param day
  //  * @return
  //  */
  //  static getDayByDate(startDate: Date, day: int): Date {
  //   return new Date(startDate.fullYear, startDate.month, startDate.date - day)
  // }

  // /**
  //  * 计算二个日期相差的天数
  //  */
  //  static getBetweenMonths(startDate: Date, endDate: Date): int {
  //   var m: int = (endDate.fullYear - startDate.fullYear) * 12 + endDate.month - startDate.month
  //   return m
  // }

  // /**
  //  * @private
  //  */
  //  static getQueryStartDate(diffYear: int = 0) {
  //   var minDate: Date = new Date()
  //   minDate.fullYear = minDate.fullYear - diffYear
  //   return DateUtils.formatStandardDate(minDate) + " 00:00:00"
  // }

  // /**
  //  * @private
  //  */
  //  static getQueryEndDate() {
  //   return DateUtils.formatStandardDateTime(new Date())
  // }

  // /**
  //  * @private
  //  */
  //  static getQueryEndDateByAddYear(diffYear: int = 0) {
  //   var minDate: Date = new Date()
  //   minDate.fullYear = minDate.fullYear + diffYear
  //   return DateUtils.formatStandardDate(minDate) + " 23:59:59"
  // }

  // /**
  //  * @private
  //  */
  //  static getSelectStartDate(dt: Date) {
  //   return DateUtils.formatStandardDate(dt) + " 00:00:00"
  // }

  // /**
  //  * @private
  //  */
  //  static getSelectEndDate(dt: Date) {
  //   return DateUtils.formatStandardDate(dt) + " 23:59:59"
  // }

  // /**
  //  * 返回指定月份的天数
  //  * @param year 年份
  //  * @param month 月份
  //  */
  //  static totalDate(y: int, m: int): int {
  //   var tempDate: Date = new Date(y, m)
  //   return tempDate.getUTCDate()
  // }

  // /**
  //  * 字符串转换成Date
  //  */
  //  static parserDate(s): Date {
  //   return DateFormatter.parseDateString(s)
  // }

  // 获取日期的星期几
  static getDayString(date) {
    const DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT']
    return date ? DAYS[date.getDay()] : DAYS[0]
  }

  // 获取跳过周六周日的x天前
  static getFourDaysAgoWithoutHoliday(date, days) {
    if (typeof date === 'string') {
      date = new Date(date)
    }
    let fourDaysAgo = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 4)
    let includingHoliday = false
    for (let i = 1; i <= days; ++i) {
      fourDaysAgo = new Date(date.getFullYear(), date.getMonth(), date.getDate() - i)
      const day = fourDaysAgo.getDay()
      if (day === 0 || day === 6) {
        includingHoliday = true
        break
      }
    }
    if (includingHoliday) {
      fourDaysAgo = new Date(date.getFullYear(), date.getMonth(), date.getDate() - days - 2)
    } else {
      fourDaysAgo = new Date(date.getFullYear(), date.getMonth(), date.getDate() - days)
    }
    return fourDaysAgo
  }

  //  static string2Date(valueString, inputFormat): Date {
  //   var mask
  //   var temp
  //   var dateString = ""
  //   var monthString = ""
  //   var yearString = ""
  //   var hourString = ""
  //   var minuteString = ""
  //   var secondString = ""
  //   var j: int = 0

  //   var n: int = inputFormat.length
  //   for (var i: int = 0 i < n i++, j++) {
  //     temp = "" + valueString.charAt(j)
  //     mask = "" + inputFormat.charAt(i)

  //     if (mask == "M") {
  //       if (isNaN(Number(temp)) || temp == " ")
  //         j--
  //       else
  //         monthString += temp
  //     }
  //     else if (mask == "D") {
  //       if (isNaN(Number(temp)) || temp == " ")
  //         j--
  //       else
  //         dateString += temp
  //     }
  //     else if (mask == "Y") {
  //       yearString += temp
  //     }
  //     else if (mask == "J") {
  //       if (isNaN(Number(temp)) || temp == " ")
  //         j--
  //       else
  //         hourString += temp
  //     }
  //     else if (mask == "N") {
  //       if (isNaN(Number(temp)) || temp == " ")
  //         j--
  //       else
  //         minuteString += temp
  //     }
  //     else if (mask == "S") {
  //       if (isNaN(Number(temp)) || temp == " ")
  //         j--
  //       else
  //         secondString += temp
  //     }
  //     else if (!isNaN(Number(temp)) && temp != " ") {
  //       return null
  //     }
  //   }

  //   temp = "" + valueString.charAt(inputFormat.length - i + j)
  //   if (!(temp == "") && (temp != " "))
  //     return null

  //   var monthNum: Number = Number(monthString)
  //   var dayNum: Number = Number(dateString)
  //   var yearNum: Number = Number(yearString)
  //   var hourNum: Number = Number(hourString)
  //   var minuteNum: Number = Number(minuteString)//如果字符串为空会转换成0
  //   var secondNum: Number = Number(secondString)
  //   if (isNaN(yearNum) || isNaN(monthNum) || isNaN(dayNum))
  //     return null

  //   if (yearString.length == 2 && yearNum < 70)
  //     yearNum += 2000

  //   var newDate: Date = new Date(yearNum, monthNum - 1, dayNum, hourNum, minuteNum, secondNum)

  //   if (dayNum != newDate.getDate() || (monthNum - 1) != newDate.getMonth())
  //     return null

  //   return newDate
  // }

  // /**
  //  * 智能托书解析ETD (DateBase.defaultStringKey返回中文的一月、二月、三月...)
  //  */
  //  static parseDateString2Intelligent(str): Date {
  //   if (!str || str == "")
  //     return null

  //   var year: int = -1
  //   var mon: int = -1
  //   var day: int = -1
  //   var hour: int = -1
  //   var min: int = -1
  //   var sec: int = -1

  //   var letter = ""
  //   var marker: Object = 0

  //   var count: int = 0
  //   var len: int = str.length

  //   // Strip out the Timezone. It is not used by the DateFormatter
  //   var timezoneRegEx: RegExp = /(GMT|UTC)((\+|-)\d\d\d\d )?/ig

  //   str = str.replace(timezoneRegEx, "")

  //   while (count < len) {
  //     letter = str.charAt(count)
  //     count++

  //     // If the letter is a blank space or a comma,
  //     // continue to the next character
  //     if (letter <= " " || letter == ",")
  //       continue

  //     // If the letter is a key punctuation character,
  //     // cache it for the next time around.
  //     if (letter == "/" || letter == ":" ||
  //       letter == "+" || letter == "-") {
  //       marker = letter
  //       continue
  //     }

  //     // Scan for groups of numbers and letters
  //     // and match them to Date parameters
  //     if ("a" <= letter && letter <= "z" ||
  //       "A" <= letter && letter <= "Z") {
  //       // Scan for groups of letters
  //       var word = letter
  //       while (count < len) {
  //         letter = str.charAt(count)
  //         if (!("a" <= letter && letter <= "z" ||
  //           "A" <= letter && letter <= "Z")) {
  //           break
  //         }
  //         word += letter
  //         count++
  //       }

  //       // Allow for an exact match
  //       // or a match to the first 3 letters as a prefix.
  //       var defaultStringKey: Array = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  //       // var n:int = DateBase.defaultStringKey.length
  //       var n: int = defaultStringKey.length
  //       for (var i: int = 0 i < n i++) {
  //         // var s:String = String(DateBase.defaultStringKey[i])
  //         var s = String(defaultStringKey[i])
  //         if (s.toLowerCase() == word.toLowerCase() ||
  //           s.toLowerCase().substr(0, 3) == word.toLowerCase()) {
  //           if (i == 13) {
  //             // pm
  //             if (hour > 12 || hour < 1)
  //               break // error
  //             else if (hour < 12)
  //               hour += 12
  //           }
  //           else if (i == 12) {
  //             // am
  //             if (hour > 12 || hour < 1)
  //               break // error
  //             else if (hour == 12)
  //               hour = 0

  //           }
  //           else if (i < 12) {
  //             // month
  //             if (mon < 0)
  //               mon = i
  //             else
  //               break // error
  //           }
  //           break
  //         }
  //       }
  //       marker = 0
  //     }

  //     else if ("0" <= letter && letter <= "9") {
  //       // Scan for groups of numbers
  //       var numbers = letter
  //       while ("0" <= (letter = str.charAt(count)) &&
  //         letter <= "9" &&
  //         count < len) {
  //         numbers += letter
  //         count++
  //       }
  //       var num: int = int(numbers)

  //       // If num is a number greater than 70, assign num to year.
  //       if (num >= 70) {
  //         if (year != -1) {
  //           break // error
  //         }
  //         else if (letter <= " " || letter == "," || letter == "." ||
  //           letter == "/" || letter == "-" || count >= len) {
  //           year = num
  //         }
  //         else {
  //           break //error
  //         }
  //       }

  //       // If the current letter is a slash or a dash,
  //       // assign num to month or day.
  //       else if (letter == "/" || letter == "-" || letter == ".") {
  //         if (mon < 0)
  //           mon = (num - 1)
  //         else if (day < 0)
  //           day = num
  //         else
  //           break //error
  //       }

  //       // If the current letter is a colon,
  //       // assign num to hour or minute.
  //       else if (letter == ":") {
  //         if (hour < 0)
  //           hour = num
  //         else if (min < 0)
  //           min = num
  //         else
  //           break //error
  //       }

  //       // If hours are defined and minutes are not,
  //       // assign num to minutes.
  //       else if (hour >= 0 && min < 0) {
  //         min = num
  //       }

  //       // If minutes are defined and seconds are not,
  //       // assign num to seconds.
  //       else if (min >= 0 && sec < 0) {
  //         sec = num
  //       }

  //       // If day is not defined, assign num to day.
  //       else if (day < 0) {
  //         day = num
  //       }

  //       // If month and day are defined and year is not,
  //       // assign num to year.
  //       else if (year < 0 && mon >= 0 && day >= 0) {
  //         year = 2000 + num
  //       }

  //       // Otherwise, break the loop
  //       else {
  //         break  //error
  //       }

  //       marker = 0
  //     }
  //   }

  //   if (year < 0 || mon < 0 || mon > 11 || day < 1 || day > 31)
  //     return null // error - needs to be a date

  //   // Time is set to 0 if null.
  //   if (sec < 0)
  //     sec = 0
  //   if (min < 0)
  //     min = 0
  //   if (hour < 0)
  //     hour = 0

  //   // create a date object and check the validity of the input date
  //   // by comparing the result with input values.
  //   var newDate: Date = new Date(year, mon, day, hour, min, sec)
  //   if (day != newDate.getDate() || mon != newDate.getMonth())
  //     return null

  //   return newDate
  // }

  // /**
  //  * 比较两个日期，若相等则将后一个日期转换成当天最大值 返回Date
  //  */
  //  static returnTodayMaxDate(a: Date, b: Date): Date {
  //   if (a == null || b == null) return null
  //   var reVal: int = ObjectUtil.dateCompare(a, b)
  //   var returnDate: Date = null
  //   if (reVal == 0)
  //     returnDate = parserDate(getSelectEndDate(b))
  //   return returnDate
  // }
  // 生成月份 格式yyyyMM
  static generationMonth(value) {
    if (value) {
      // 获取月份
      let year = value.slice(0, 4)
      // 获取年份
      let month = value.slice(4)

      if (month > 12) {
        year = Number(year) + 1
        month = '01'
      }
      if (month <= 0) {
        year = Number(year) - 1
        month = '12'
      }
      return year + month
    }
    return ''
  }

  /**
   * 字符串日期转换成时间戳
   * @param date
   * @returns {null|number}
   */
  static strDateToTimestamp(date) {
    if (!date) {
      return null
    }
    return new Date(date).getTime()
  }

  /**
   * 标准的详细时间
   * @param d
   * @return
   */
  static formatStandardMinuteTime(d) {
    if (d) {
      return moment(d).format(this.STANDARD_MINUTE_TIME)
    }
    return ''
  }

  static formatDate(date, format) {
    const year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    month = month < 10 ? '0' + month : month
    day = day < 10 ? '0' + day : day
    return format.replace('yyyy', year).replace('MM', month).replace('dd', day)
  }

  /**
   * 获取指定日期区间，指定周几的日期列表
   * @param startDate 开始时间
   * @param endDate 结束时间
   * @param weekdays 周几：1/2/3，或1,2,3，或123都可以
   * @returns {*[]}
   */
  static getDatesByWeekdays(startDate, endDate, weekdays) {
    const dates = []
    const currentDate = new Date(startDate)
    const end = new Date(endDate)
    while (currentDate <= end) {
      if (weekdays.includes(currentDate.getDay().toString())) {
        dates.push(new Date(currentDate))
      }
      currentDate.setDate(currentDate.getDate() + 1)
    }
    return dates
  }
  /**
   * 获取指定日期区间，指定周几的日期列表
   * @param startDate 开始时间
   * @param endDate 结束时间
   * @param weekdays 周几：1/2/3，或1,2,3，或123都可以
   * @returns {*[]}
   */
  static getDatesByWeekdaysFormat(startDate, endDate, weekdays, format = 'yyyy-MM-dd') {
    const dates = []
    const currentDate = new Date(startDate)
    const end = new Date(endDate)
    // CARGO-38736 运价查询ETD显示异常
    let days = weekdays
    if (weekdays === 'daily') {
      days = '1/2/3/4/5/6/7'
    }
    days = days.replace('7', '0')
    while (currentDate <= end) {
      if (days.includes(currentDate.getDay().toString())) {
        dates.push(this.formatDate(currentDate, format))
      }
      currentDate.setDate(currentDate.getDate() + 1)
    }
    return dates
  }

  /**
   * 日期向前或向后指定天数
   * @param dateString
   * @param days
   * @returns {Date}
   */
  static addDays(dateString, days) {
    // 解析日期字符串为毫秒数
    const dateMillis = Date.parse(dateString)
    // 创建一个Date对象
    const date = new Date(dateMillis)
    // 获取当前日期
    const currentDate = date.getDate()
    // 设置新日期
    date.setDate(currentDate + days)
    // 返回ISO格式的字符串
    return date
  }

  /**
   * 日期向前或向后指定天数
   * @param dateString
   * @param days
   * @returns {Date}
   */
  static addDays2(dateString, days) {
    const date = this.addDays(dateString, days)
    const dateMill = Date.parse(this.formatStandardDate(date) + ' 00:00:00')
    return new Date(dateMill)
  }

  /**
   * 对指定日期增加或减少小时数
   * @param {string | Date} date 原始日期（可以是字符串、Date 对象或时间戳）
   * @param {number} hours 要增加或减少的小时数（可为负数）
   * @returns {Date} 新的 Date 对象
   */
  static addHours(date, hours) {
    const d = new Date(date) // 兼容字符串、时间戳、Date 对象
    if (isNaN(d.getTime())) {
      return d
    }
    d.setHours(d.getHours() + hours)
    return d
  }

  /**
   * 判断日期间隔月数是否等于month以内
   * @param date1
   * @param date2
   * @param month
   * @returns {boolean}
   */
  static isWithinMonths(date1, date2, month) {
    const d1 = new Date(date1)
    const d2 = new Date(date2)

    // 计算年份和月份的差值
    const yearDiff = d2.getFullYear() - d1.getFullYear()
    const monthDiff = d2.getMonth() - d1.getMonth()

    // 计算总的月份差值
    const totalMonthsDiff = yearDiff * 12 + monthDiff
    // 判断日期间隔是否在3个月以内
    if (totalMonthsDiff < month) {
      return true
    }
    if (totalMonthsDiff > month) {
      return false
    }
    if (totalMonthsDiff === month) {
      // 如果间隔正好是3个月，还需要检查天数是否超过
      const dayDiff = d2.getDate() - d1.getDate()
      if (dayDiff > 0) {
        return false
      }
    }
    return true
  }

  static dateFormatYmdHms(dateString) {
    const date = new Date(dateString)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  static toDateStr(dateStr) {
    if (!dateStr) {
      return ''
    }
    // 验证日期距离1970年是多长时间，转换之后是否是数字、验证传入的日期是否是数字，若是数字则长度不能少于8位
    if (isNaN(Date.parse(dateStr)) || dateStr.length < 8) {
      return ''
    }
    const date = new Date(dateStr)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    // 验证日期转换之后年月日是否正确
    if (isNaN(year) || isNaN(month) || isNaN(day) || month <= 0 || month > 12 || day < 0 || day > 31) {
      return ''
    }
    return DateUtils.formatStandardDate(date)
  }

  static toDateStrByFormat(dateStr, format) {
    if (!dateStr) {
      return ''
    }
    // 验证日期距离1970年是多长时间，转换之后是否是数字、验证传入的日期是否是数字，若是数字则长度不能少于8位
    if (isNaN(Date.parse(dateStr)) || dateStr.length < 8) {
      return ''
    }
    if (dateStr.trim().length === 10) {
      dateStr = dateStr + ' 00:00:00'
    }
    const date = new Date(dateStr)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    // 验证日期转换之后年月日是否正确
    if (isNaN(year) || isNaN(month) || isNaN(day) || month <= 0 || month > 12 || day < 0 || day > 31) {
      return ''
    }
    return DateUtils.customFormat(date, format)
  }

  /**
   * 按年月日判断（数组）是否包含指定日期
   * @param dateArray
   * @param targeDate
   */
  static includesByYearMonthDay(dateArray, targeDate) {
    return dateArray.findIndex(p => this.equalYearMonthDay(p, targeDate)) > -1
  }

  /**
   * 比较年月日是否相等
   * @param date1
   * @param date2
   * @returns
   */
  static equalYearMonthDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()
  }
}
export default DateUtils
